<template>
    <section class="mb-8">
        <h4 class="text-slate-800 dark:text-slate-100 font-medium mb-4">Train travel</h4>
        <div class="px-4 py-5 rounded-lg border border-slate-200 dark:border-slate-700">
            <div
                class="flex justify-between pb-3 mb-4 border-b border-slate-200 dark:border-slate-700"
            >
                <div class="text-slate-800 dark:text-slate-100 text-sm font-medium">
                    <span v-if="!hideSensitiveData">
                        {{ travelDate }}
                    </span>
                    <span v-else class="text-slate-400">Hidden</span>
                </div>
                <div class="flex items-center gap-2 text-slate-500 dark:text-slate-400">
                    <TripsIcon icon="user" class="w-5 h-5 text-slate-500 dark:text-slate-400" />
                    {{ activeRedemption.number_of_travelers }}
                </div>
            </div>
            <div>
                <div
                    class="flex justify-between flex-wrap"
                    v-for="(segment, i) in activeRedemption.travel_segments"
                    :key="segment.id"
                >
                    <div class="pl-2 w-full max-w-[70%]">
                        <div class="pb-4 pl-3 relative">
                            <div
                                class="w-3 h-3 rounded-full border-2 bg-white dark:bg-slate-800 border-slate-400 absolute top-[5px] -left-1.5 z-10"
                            ></div>
                            <div
                                class="absolute w-1 border-l border-dashed border-slate-400 -left-[1px] top-1.5 -bottom-1"
                            ></div>
                            <p class="text-slate-800 dark:text-slate-100 text-sm">
                                {{ segment.origin }}
                            </p>
                        </div>
                        <div class="pl-3 relative">
                            <div
                                class="w-3 h-3 rounded-full border-2 bg-white dark:bg-slate-800 border-slate-400 absolute top-[5px] -left-1.5 z-10"
                            ></div>
                            <p class="text-slate-800 dark:text-slate-100 text-sm">
                                {{ segment.destination }}
                            </p>
                        </div>
                    </div>
                    <div class="w-full max-w-[30%] min-w-30">
                        <div
                            class="flex items-center gap-2 text-slate-500 dark:text-slate-400 text-sm"
                        >
                            <TripsIcon
                                icon="train"
                                class="w-5 h-5 text-slate-500 dark:text-slate-400"
                            />
                            Train {{ segment.travel_number }}
                        </div>
                    </div>

                    <div
                        class="w-full flex items-center gap-2 mt-4 mb-4 px-3 py-2 text-slate-800 dark:text-slate-100 bg-slate-100 dark:bg-slate-700 text-sm rounded"
                        v-if="activeRedemption.travel_segments[i + 1]"
                    >
                        <TripsIcon icon="person-walk" class="text-slate-500 dark:text-slate-400" />
                        Layover in
                        {{ activeRedemption.travel_segments[i + 1].origin }}
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>
<script setup>
import { computed } from 'vue';
import dayjs from 'dayjs';
import TripsIcon from '@/components/trips/icons.vue';

const props = defineProps({
    activeRedemption: Object,
    isSharedView: {
        type: Boolean,
        default: false,
    },
    hideSensitiveData: {
        type: Boolean,
        default: false,
    },
});

const travelDate = computed(() => {
    if (!props.activeRedemption?.start_date) return '';
    return dayjs(props.activeRedemption.start_date).format('MMM D') +
        (props.activeRedemption.end_date ? ' - ' : '') +
        (props.activeRedemption.end_date
            ? dayjs(props.activeRedemption.end_date).format('MMM D, YYYY')
            : '');
});
</script>
